(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};

import React from 'react';
import { Row, Col, Table } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import '../assets/styles/components/Floorplans.scss';
import 'blueimp-gallery/css/blueimp-gallery.min.css';
const floorplansList = [{
  path: 'studio',
  title: 'studio',
  beds: 'Studio',
  baths: '1',
  price: '',
  ApplyLink: 'https://mosaicstudent.appfolio.com/listings/rental_applications/new?listable_uid=4b3fad0b-0709-4fc6-b6ff-8d21f7d8259b&source=Website'
}, {
  path: 'jr',
  title: 'Junior',
  beds: '2',
  baths: '1',
  // sqft: "310",
  price: '',
  ApplyLink: 'https://mosaicstudent.appfolio.com/listings/rental_applications/new?listable_uid=ba00dbb6-4be3-4d81-9bf7-f780f7ce4556&source=Website'
}, {
  path: 'standard',
  title: 'Standard',
  beds: '2',
  baths: '2',
  // sqft: "310",
  price: '',
  ApplyLink: 'https://mosaicstudent.appfolio.com/listings/rental_applications/new?listable_uid=9d4ac84f-cf12-4c10-aa7a-7d96d8e42317&source=Website'
}, {
  path: 'luxe',
  title: 'Luxe',
  beds: '2',
  baths: '2',
  // sqft: "310",
  price: '',
  ApplyLink: 'https://mosaicstudent.appfolio.com/listings/rental_applications/new?listable_uid=e8dc7be4-0dc3-4f7b-95ab-6471b732e887&source=Website'
}];
const classBtn = 'list-group-item list-group-item-action list-group-item-secondary';

class Floorplans extends React.Component {
  constructor(props) {
    super(props);
    this.goBlueimp = this.goBlueimp.bind(this);
  }

  componentDidMount() {
    this.goBlueimp();
  }

  goBlueimp() {
    const GalleryPic = require('blueimp-gallery');

    document.getElementById('parentgallery').onclick = function (evt) {
      let event = evt;
      event = event || window.event;
      const target = event.target || event.srcElement,
            link = target.parentNode,
            options = {
        index: link,
        event
      },
            links = this.getElementsByClassName('imagefloorplan');

      if (options.index.className.toLowerCase() === 'imagefloorplan') {
        event.preventDefault();
        GalleryPic(links, options);
      }
    };

    const Gallery = require('blueimp-gallery');

    document.getElementById('linksgallery').onclick = function (evt) {
      let event = evt;
      event = event || window.event;
      const target = event.target || event.srcElement,
            link = target,
            options = {
        index: link,
        event
      },
            links = this.getElementsByClassName('btn-outline-primary');

      if (options.index.className.toLowerCase() === 'btn btn-outline-primary btn-block') {
        event.preventDefault();
        Gallery(links, options);
      }
    };
  }

  render() {
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
      className: "list-group list-group-horizontal text-center"
    }, /*#__PURE__*/React.createElement(Link, {
      to: "/floorplans",
      className: this.props.beds == '' ? classBtn + ' active' : classBtn
    }, "All"), /*#__PURE__*/React.createElement(Link, {
      to: "/floorplans/studios",
      className: this.props.beds == 'studio' ? classBtn + ' active' : classBtn
    }, "Studio"), /*#__PURE__*/React.createElement(Link, {
      to: "/floorplans/2-bedrooms",
      className: this.props.beds == '2' ? classBtn + ' active' : classBtn
    }, "2 Beds")), /*#__PURE__*/React.createElement("div", {
      id: "parentgallery"
    }, /*#__PURE__*/React.createElement("div", {
      id: "linksgallery",
      className: "resultfloorplans"
    }, floorplansList.filter(unit => unit.beds.toLowerCase().includes(this.props.beds.toLowerCase())).map((unit, i) => /*#__PURE__*/React.createElement(ItemFloor, {
      key: i,
      path: unit.path,
      title: unit.title,
      beds: unit.beds,
      baths: unit.baths,
      sqft: unit.sqft,
      price: unit.price,
      link: unit.ApplyLink
    })))), /*#__PURE__*/React.createElement("div", {
      id: "blueimp-gallery",
      className: "blueimp-gallery blueimp-gallery-controls"
    }, /*#__PURE__*/React.createElement("div", {
      className: "slides"
    }), /*#__PURE__*/React.createElement("h3", {
      className: "title"
    }), /*#__PURE__*/React.createElement("a", {
      role: "button",
      className: "prev"
    }, "\u2039"), /*#__PURE__*/React.createElement("a", {
      role: "button",
      className: "next"
    }, "\u203A"), /*#__PURE__*/React.createElement("a", {
      role: "button",
      className: "close"
    }, "\xD7")));
  }

  // @ts-ignore
  __reactstandin__regenerateByEval(key, code) {
    // @ts-ignore
    this[key] = eval(code);
  }

}

const ItemFloor = ({
  path,
  title,
  beds,
  baths,
  sqft,
  price,
  link
}) => {
  return /*#__PURE__*/React.createElement("div", {
    className: "cardamenity"
  }, /*#__PURE__*/React.createElement("a", {
    href: `/images/floorplans/large/${beds.toLowerCase()}/${path}.jpg`,
    className: "imagefloorplan"
  }, /*#__PURE__*/React.createElement("img", {
    src: `/images/floorplans/${beds.toLowerCase()}/${path}.jpg`,
    alt: `Floorplan ${path}`,
    className: "img-fluid",
    width: "246",
    height: "285"
  })), /*#__PURE__*/React.createElement("div", {
    className: "detailfloor"
  }, /*#__PURE__*/React.createElement("h3", {
    className: "h2"
  }, title), /*#__PURE__*/React.createElement(Table, null, /*#__PURE__*/React.createElement("caption", {
    className: "sr-only"
  }, title, " - Details"), /*#__PURE__*/React.createElement("tbody", null, /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("th", null, "Beds"), /*#__PURE__*/React.createElement("td", null, beds)), /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("th", null, "Baths"), /*#__PURE__*/React.createElement("td", null, baths)), /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("th", null, "Price"), /*#__PURE__*/React.createElement("td", null, price != '' ? `$${price}` : 'Call for details'))))), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
    md: 6
  }, /*#__PURE__*/React.createElement("a", {
    href: `/images/floorplans/large/${beds.toLowerCase()}/${path}.jpg`,
    className: "btn btn-outline-primary btn-block"
  }, "View Floor Plan")), /*#__PURE__*/React.createElement(Col, {
    md: 6
  }, /*#__PURE__*/React.createElement("a", {
    href: link,
    target: "_blank",
    className: "btn btn-secondary btn-block"
  }, "Apply Now", /*#__PURE__*/React.createElement("span", {
    className: "sr-only"
  }, " (opens in new window)")))));
};

const _default = Floorplans;
export default _default;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(floorplansList, "floorplansList", "/var/www/html/websites/thedistrictusc-com/src/frontend/components/result-floorplans.jsx");
  reactHotLoader.register(classBtn, "classBtn", "/var/www/html/websites/thedistrictusc-com/src/frontend/components/result-floorplans.jsx");
  reactHotLoader.register(Floorplans, "Floorplans", "/var/www/html/websites/thedistrictusc-com/src/frontend/components/result-floorplans.jsx");
  reactHotLoader.register(ItemFloor, "ItemFloor", "/var/www/html/websites/thedistrictusc-com/src/frontend/components/result-floorplans.jsx");
  reactHotLoader.register(_default, "default", "/var/www/html/websites/thedistrictusc-com/src/frontend/components/result-floorplans.jsx");
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();